<template>
  <header id="header">
    <router-link to="/" name="page d'accueil">
      <img
        class="logo"
        src="@/assets/images/SVG/logo_idtroc.svg"
        id="logo"
        alt="logoo idtroc accèder à notre page d'accueil"
      />
    </router-link>
  </header>
</template>
<script>
import Parallax from "@/assets/js/parallax";

export default {
  name: "idtrocHeader",
  mounted: function() {
    this.pageInit();
  },
  methods: {
    pageInit: function() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue